// extracted by mini-css-extract-plugin
export default {"def_wrap_hide":"definition_def_wrap_hide__t90YY","def_wrap_show":"definition_def_wrap_show__JUqYl","text_wrap":"definition_text_wrap__-8mjK","def_img":"definition_def_img__cUKFZ"};